import { Link } from 'react-router-dom';

import { useUserContext } from '../../Contexts/User';
import { Breadcrumb } from '../components/breadcrumb';
import { Icon } from '../components/icon';
import { PageContainer } from '../components/page-container';
import { PageHeader } from '../components/page-header';
import { PageTitle } from '../components/page-title';
import { Button } from '../components/shadcn/button';

export function Home() {
  const { user } = useUserContext();
  if (!user) return null;

  return (
    <>
      <Breadcrumb items={[{ href: '/', label: 'Home', active: true }]} />

      <PageContainer>
        <PageHeader>
          <PageTitle text={`Welcome back ${user.email}...`} />
        </PageHeader>

        <Link to="/app/chronos/matters">
          <Button>
            <Icon className="lucide--external-link" />
            Go back to the main app
          </Button>
        </Link>
      </PageContainer>
    </>
  );
}
